(function () {
  'use strict';

  if (!/^\/products\//.test(window.location.pathname)) return;
  if (document.getElementById('mmProduktPcStilV5')) return;

  var stil = document.createElement('style');
  stil.id = 'mmProduktPcStilV5';
  stil.textContent = [
    'html body .mmAboEng .subscription_group[data-mm-abo-rabatt]{padding-top:38px!important}',
    'html body .mmAboEng .subscription_group[data-mm-abo-rabatt]:has(input:checked){padding-top:37px!important}',
    'html body .mmAboEng .subscription_group[data-mm-abo-rabatt]:after{top:8px!important;right:8px!important}',
    '.mmAboEng{--mmVorratAkzent:#F47A24;--mmVorratZweit:#E8C37A;--mmVorratZweitText:#151013}',
    '.mmAboEng[data-mm-vorrat-sorte="strawberry"]{--mmVorratAkzent:#E5142A;--mmVorratZweit:#FF4B7E;--mmVorratZweitText:#fff}',
    '.mmAboEng[data-mm-vorrat-sorte="nuss"]{--mmVorratAkzent:#287A58;--mmVorratZweit:#9CCC3C;--mmVorratZweitText:#151013}',
    '.mmAboEng[data-mm-vorrat-sorte="florea"]{--mmVorratAkzent:#D63E75;--mmVorratZweit:#F2A8C2;--mmVorratZweitText:#151013}',
    '.mmAboEng .mmAboMengenToggle{background-color:#fff!important;border:1.5px solid rgba(21,16,19,.28)!important;border-radius:14px!important;box-shadow:none!important;transition:border-color .22s ease,background-color .22s ease!important}',
    '.mmAboEng .mmAboMengenToggle:hover{border-color:#151013!important;background-color:#F8F5F6!important;box-shadow:none!important}',
    'html body .mmAboEng .mmAboMengenPfeil{position:relative!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;gap:5px!important;flex:0 0 auto!important;width:auto!important;height:27px!important;min-width:78px!important;margin:0!important;padding:0 9px!important;overflow:hidden!important;border:1px solid rgba(21,16,19,.3)!important;border-radius:999px!important;background:#fff!important;color:#151013!important;font-family:"MM Poppins","MM Bricolage",sans-serif!important;font-size:.53rem!important;line-height:1!important;font-weight:800!important;letter-spacing:0!important;box-shadow:none!important;transform:none!important;transition:background-color .22s ease,color .22s ease,border-color .22s ease!important}',
    'html body .mmAboEng .mmAboMengenPfeil:before{content:"+"!important;display:inline-grid!important;place-items:center!important;width:10px!important;height:10px!important;color:currentColor!important;font-size:.72rem!important;line-height:10px!important;font-weight:700!important}',
    'html body .mmAboEng .subscription_group.mmAboMengenOffen .mmAboMengenPfeil{border-color:#151013!important;background:#151013!important;color:#fff!important;box-shadow:none!important;transform:none!important}',
    'html body .mmAboEng .subscription_group.mmAboMengenOffen .mmAboMengenPfeil:before{content:"\u2212"!important}',
    'html body .mmAboEng .mmAboMengenToggle:active .mmAboMengenPfeil{background-color:#EDE8EA!important}',
    'html body .mmAboEng .subscription_group.mmAboMengenOffen .mmAboMengenToggle:active .mmAboMengenPfeil{background-color:#151013!important}',
    'html body .mmAboEng .mmAboMengenToggle:focus-visible{outline:2px solid #151013!important;outline-offset:3px!important}',
    '.mmAboEng .mmAboMengenPanel{gap:10px!important}',
    '.mmAboEng .mmAboMengenOption{position:relative!important;overflow:hidden!important;min-height:86px!important;padding:12px!important;border:1.5px solid rgba(21,16,19,.15)!important;border-radius:16px!important;background-color:#fff!important;box-shadow:0 7px 20px rgba(21,16,19,.055),inset 0 1px 0 rgba(255,255,255,.95)!important;transition:transform .3s cubic-bezier(.22,.61,.36,1),border-color .3s cubic-bezier(.22,.61,.36,1),box-shadow .3s cubic-bezier(.22,.61,.36,1),background-color .3s cubic-bezier(.22,.61,.36,1)!important}',
    '.mmAboEng .mmAboMengenOption:hover{transform:translateY(-2px)!important;border-color:rgba(21,16,19,.5)!important;box-shadow:0 12px 26px rgba(21,16,19,.1),inset 0 1px 0 #fff!important}',
    '.mmAboEng .mmAboMengenOption.mmAboMengenAktiv{border:2px solid #151013!important;background-color:#F8F5F6!important;box-shadow:0 0 0 1px rgba(21,16,19,.08),0 12px 28px rgba(21,16,19,.12)!important;transform:translateY(-1px)!important}',
    '.mmAboEng .mmAboMengenOption[data-mm-auszeichnung]{justify-content:flex-start!important;min-height:108px!important}',
    '.mmAboEng .mmAboMengenOption:not([data-mm-auszeichnung]){justify-content:center!important}',
    '.mmAboEng .mmAboMengenOption[data-mm-auszeichnung="bestseller"]{box-shadow:inset 0 3px 0 var(--mmVorratAkzent),0 7px 20px rgba(21,16,19,.055)!important}',
    '.mmAboEng .mmAboMengenOption[data-mm-auszeichnung="halbjahr"]{box-shadow:inset 0 3px 0 var(--mmVorratZweit),0 7px 20px rgba(21,16,19,.055)!important}',
    '.mmAboEng .mmAboMengenOption[data-mm-auszeichnung="langzeit"]{box-shadow:inset 0 3px 0 #151013,0 7px 20px rgba(21,16,19,.055)!important}',
    '.mmAboEng .mmAboMengenOption[data-mm-auszeichnung].mmAboMengenAktiv{box-shadow:inset 0 3px 0 var(--mmVorratKante,#151013),0 0 0 1px rgba(21,16,19,.08),0 12px 28px rgba(21,16,19,.12)!important}',
    '.mmAboEng .mmAboMengenOption strong{font-size:.72rem!important;letter-spacing:-.015em!important}',
    '.mmAboEng .mmAboMengenOption span{font-size:.64rem!important}',
    '.mmAboEng .mmAboMengenOption .mmAboMengenRabatt,.mmAboEng .mmAboMengenOption em{font-size:.62rem!important}',
    '.mmAboEng .mmAboMengenOption .mmAboMengenBadge{position:relative!important;display:inline-flex!important;align-items:center!important;max-width:100%!important;min-height:20px!important;margin:0 0 8px!important;padding:5px 7px!important;overflow:hidden!important;border-radius:999px!important;color:#fff!important;font-size:.51rem!important;line-height:1!important;font-weight:900!important;letter-spacing:.018em!important;white-space:nowrap!important;box-shadow:0 5px 12px rgba(21,16,19,.16),inset 0 1px 0 rgba(255,255,255,.42)!important}',
    '.mmAboEng [data-mm-auszeichnung="bestseller"] .mmAboMengenBadge{background-color:var(--mmVorratAkzent)!important}',
    '.mmAboEng [data-mm-auszeichnung="halbjahr"] .mmAboMengenBadge{background-color:var(--mmVorratZweit)!important;color:var(--mmVorratZweitText)!important}',
    '.mmAboEng [data-mm-auszeichnung="langzeit"] .mmAboMengenBadge{background-color:#151013!important}',
    '.mmAboEng .mmAboMengenOption[data-mm-auszeichnung="langzeit"]{grid-column:1/-1!important;display:grid!important;grid-template-columns:max-content minmax(0,1fr) max-content!important;grid-template-rows:auto auto!important;column-gap:12px!important;row-gap:2px!important;align-items:center!important;min-height:78px!important}',
    '.mmAboEng [data-mm-auszeichnung="langzeit"] .mmAboMengenBadge{grid-column:1!important;grid-row:1/3!important;margin:0!important}',
    '.mmAboEng [data-mm-auszeichnung="langzeit"]>strong{grid-column:2!important;grid-row:1!important;align-self:end!important}',
    '.mmAboEng [data-mm-auszeichnung="langzeit"]>span:not(.mmAboMengenBadge):not(.mmAboMengenRabatt){grid-column:2!important;grid-row:2!important;align-self:start!important}',
    '.mmAboEng [data-mm-auszeichnung="langzeit"]>.mmAboMengenRabatt{grid-column:3!important;grid-row:1!important;align-self:end!important;text-align:right!important}',
    '.mmAboEng [data-mm-auszeichnung="langzeit"]>em{grid-column:3!important;grid-row:2!important;align-self:start!important;text-align:right!important}',
    '.mmAboEng .mmAboMengenBadge:after{content:"";position:absolute;top:0;bottom:0;left:0;width:42%;background-image:linear-gradient(90deg,transparent,rgba(255,255,255,.78),transparent);transform:skewX(-18deg);animation:mmVorratGlanz 2.6s cubic-bezier(.22,.61,.36,1) infinite;animation-play-state:paused;pointer-events:none}',
    '.mmAboEng.mmVorratSichtbar .mmAboMengenBadge:after{animation-play-state:running}',
    '@keyframes mmVorratGlanz{0%,34%{translate:-180% 0}72%,100%{translate:480% 0}}',
    '@media (min-width:900px){',
    'html body .product-information__grid.product-information--media-left{grid-column:1/-1!important;grid-template-columns:minmax(0,640px) minmax(440px,520px)!important;column-gap:32px!important;width:calc(100% - 48px)!important;max-width:1192px!important;margin-inline:auto!important}',
    'html body .product-information__grid.product-information--media-left>.product-information__media{grid-column:1!important;width:100%!important;min-width:0!important;padding-right:0!important}',
    'html body .product-information__grid.product-information--media-left>.product-details{grid-column:2!important;width:100%!important;max-width:520px!important;min-width:0!important;padding-left:0!important}',
    'html body .product-information__media media-gallery{width:100%!important;max-width:640px!important;margin-inline:auto!important}',
    'html body .mmAboEng .plan_card{grid-template-columns:minmax(0,1fr)!important;align-items:start!important;gap:10px!important}',
    'html body .mmAboEng .subscription_group{align-self:start!important;min-height:106px!important}',
    'html body .mmAboEng .mmAboMengenToggle{min-height:48px!important;padding:11px 14px!important;font-size:.8rem!important}',
    'html body .mmAboEng .mmAboMengenPanel{grid-template-columns:repeat(3,minmax(0,1fr))!important}',
    'html body .mmAboEng .mmAboMengenOption{padding:12px 13px!important}',
    'html body .mmAboEng .mmAboMengenOption strong{font-size:.84rem!important;line-height:1.15!important}',
    'html body .mmAboEng .mmAboMengenOption span{font-size:.72rem!important;line-height:1.2!important}',
    'html body .mmAboEng .mmAboMengenOption .mmAboMengenRabatt{font-size:.68rem!important;line-height:1.2!important}',
    'html body .mmAboEng .mmAboMengenOption em{font-size:.68rem!important;line-height:1.2!important}',
    '}',
    '@media (max-width:560px){.mmAboEng .mmAboMengenPanel{gap:8px!important}.mmAboEng .mmAboMengenOption[data-mm-auszeichnung]{min-height:98px!important}.mmAboEng .mmAboMengenOption .mmAboMengenBadge{min-height:18px!important;padding:4px 6px!important;font-size:.47rem!important}.mmAboEng .mmAboMengenOption[data-mm-auszeichnung="langzeit"]{min-height:72px!important;column-gap:8px!important}html body .mmAboEng .mmAboMengenPfeil{height:26px!important;min-width:74px!important;padding:0 8px!important;font-size:.5rem!important}.mmAboEng .mmAboMengenAktuell{overflow:hidden!important;text-overflow:ellipsis!important}}',
    '@media (prefers-reduced-motion:reduce){.mmAboEng .mmAboMengenOption,.mmAboEng .mmAboMengenToggle,.mmAboEng .mmAboMengenPfeil{transition:none!important}.mmAboEng .mmAboMengenBadge:after{animation:none!important}}'
  ].join('');
  document.head.appendChild(stil);

  var auszeichnungen = {
    '3': { name: 'bestseller', text: 'BESTSELLER' },
    '6': { name: 'halbjahr', text: 'HALBJAHRES-HIT' },
    '12': { name: 'langzeit', text: 'JAHRES-VORTEIL' }
  };
  var abo = null;
  var imBild = false;
  var autoZiel = null;
  var autoImBild = false;
  var autoLaeuft = false;
  var sichtWache = 'IntersectionObserver' in window ? new IntersectionObserver(function (eintraege) {
    imBild = !!(eintraege[0] && eintraege[0].isIntersecting);
    sichtbarkeit();
  }, { threshold: 0.08 }) : null;
  var autoWache = 'IntersectionObserver' in window ? new IntersectionObserver(function (eintraege) {
    autoImBild = !!(eintraege[0] && eintraege[0].isIntersecting && eintraege[0].intersectionRatio >= 0.32);
    autoPlanen();
  }, { threshold: [0, 0.32, 0.6], rootMargin: '0px 0px -8% 0px' }) : null;

  function sorte() {
    var h1 = document.querySelector('main h1');
    var text = (window.location.pathname + ' ' + document.title + ' ' + (h1 ? h1.textContent : '')).toLowerCase();
    if (/magic-fruit|florea/.test(text)) return 'florea';
    if (/zero-termo|zerotermo|nuss|pro.?milk/.test(text)) return 'nuss';
    if (/erdbeer|strawberry/.test(text)) return 'strawberry';
    return 'standard';
  }

  function sichtbarkeit() {
    if (!abo) return;
    abo.classList.toggle('mmVorratSichtbar', imBild && !document.hidden);
  }

  function schalterText() {
    if (!abo) return;
    abo.querySelectorAll('.mmAboMengenToggle').forEach(function (schalter) {
      var pfeil = schalter.querySelector('.mmAboMengenPfeil');
      if (!pfeil) return;
      var text = schalter.getAttribute('aria-expanded') === 'true' ? 'Schlie\u00DFen' : '\u00D6ffnen';
      if (pfeil.textContent !== text) pfeil.textContent = text;
    });
  }

  function autoStoppen(fertig) {
    if (fertig) {
      document.documentElement.setAttribute('data-mm-abo-auto-v5', '1');
      document.documentElement.removeAttribute('data-mm-abo-auto-wartet-v5');
    }
  }

  function autoPlanen() {
    if (!autoZiel || document.hidden || document.documentElement.hasAttribute('data-mm-abo-auto-v5')) {
      return;
    }
    if (!autoImBild) {
      return;
    }
    if (document.documentElement.hasAttribute('data-mm-abo-auto-wartet-v5')) return;
    document.documentElement.setAttribute('data-mm-abo-auto-wartet-v5', '1');
    window.setTimeout(function () {
      document.documentElement.removeAttribute('data-mm-abo-auto-wartet-v5');
      if (!autoZiel || !autoImBild || document.hidden || document.documentElement.hasAttribute('data-mm-abo-auto-v5')) return;
      var gruppe = autoZiel.closest('.subscription_group[data-mm-abo-rabatt]') || (abo && abo.querySelector('.subscription_group[data-mm-abo-rabatt]'));
      var schalter = gruppe && gruppe.querySelector('.mmAboMengenToggle');
      var radio = gruppe && gruppe.querySelector('input[type="radio"]');
      if (!gruppe || !schalter) return;
      autoStoppen(true);
      autoLaeuft = true;
      if (schalter.getAttribute('aria-expanded') !== 'true') {
        if (radio && !radio.checked) radio.click();
        else schalter.click();
      }
      autoLaeuft = false;
      window.requestAnimationFrame(schalterText);
    }, 720);
  }

  function manuell() {
    if (autoLaeuft) return;
    autoStoppen(true);
  }

  function verbinden() {
    var neu = document.querySelector('.mmAboEng');
    if (!neu) return;
    if (neu !== abo) {
      if (abo && sichtWache) sichtWache.unobserve(abo);
      abo = neu;
      abo.setAttribute('data-mm-vorrat-sorte', sorte());
      if (sichtWache) sichtWache.observe(abo);
      else imBild = true;
      abo.addEventListener('pointerdown', manuell, true);
      abo.addEventListener('keydown', manuell, true);
    }
    var neuesAutoZiel = neu.querySelector('.mmAboMengenwahl') || neu;
    if (neuesAutoZiel !== autoZiel) {
      if (autoZiel && autoWache) autoWache.unobserve(autoZiel);
      autoZiel = neuesAutoZiel;
      autoImBild = false;
      if (autoWache) autoWache.observe(autoZiel);
      else {
        autoImBild = true;
        autoPlanen();
      }
    }
    abo.querySelectorAll('.mmAboMengenToggle').forEach(function (schalter) {
      if (schalter.getAttribute('data-mm-zustand-v5')) return;
      schalter.setAttribute('data-mm-zustand-v5', '1');
      schalter.addEventListener('click', function () {
        window.requestAnimationFrame(schalterText);
      });
    });
    abo.querySelectorAll('.mmAboMengenOption').forEach(function (option) {
      var wert = option.getAttribute('data-mm-abo-menge');
      var auszeichnung = auszeichnungen[wert];
      if (!auszeichnung || option.querySelector('.mmAboMengenBadge')) return;
      option.setAttribute('data-mm-auszeichnung', auszeichnung.name);
      option.style.setProperty('--mmVorratKante', auszeichnung.name === 'bestseller' ? 'var(--mmVorratAkzent)' : auszeichnung.name === 'halbjahr' ? 'var(--mmVorratZweit)' : '#151013');
      var badge = document.createElement('span');
      badge.className = 'mmAboMengenBadge';
      badge.textContent = auszeichnung.text;
      option.insertBefore(badge, option.firstChild);
    });
    sichtbarkeit();
    schalterText();
  }

  var aenderungsWache = new MutationObserver(verbinden);
  aenderungsWache.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('visibilitychange', function () {
    sichtbarkeit();
    autoPlanen();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', verbinden);
  else verbinden();
})();
